<template>

<app-input :label="label">

	<slot></slot>

</app-input>

</template>

<script>

export default {

    props: ['label']

}

</script>

<style scoped>

</style>
